import React, { useMemo } from "react";
import StickyGroupHeader from "../group-header/StickyGroupHeader";
import { useTranslate } from "../../translate";
import { connect } from "../../store";

export const colors = {
    white: "#ffffff",
    orangeMedium: "#FFEACA",
    blueLight: "#D3E5FF",
    purpleLight: "#7875F9",
};

function ItineraryDay(props) {
    const translate = useTranslate();
    const {
        dayNumberFixed,
        dayNumber,
        distance,
        topOffset,
        isActiveStopOvernight,
        dayId,
        activeDayId,
        setIsOpenItinerarySwitcher,
        showItinerarySwitcher,
        inLauncherModal,
        withSticky,
        isStickyOverride,
    } = props;
    const showDistance = distance !== 0 && distance;
    const dayDistance = showDistance ? distance.toFixed(1) + "km" : "";
    const progress = props.progressByDay[dayNumber];
    const hasReachedStopOvernight = progress === 100 || (progress > 0 && isActiveStopOvernight);
    const color = hasReachedStopOvernight ? "#ffffff" : null;
    const isActive = dayId === activeDayId;
    let [bgColor, iconName, iconColor, iconBorderColor] = useMemo(() => {
        if (hasReachedStopOvernight) {
            return [colors.purpleLight, "moonrise", "#D3D2FC", "#A7A5F9"];
        } else if (progress > 33) {
            return [colors.blueLight, "sunrise", "#60A1FF", "#8FBDFF"];
        } else if (progress > 0 || isActive) {
            return [colors.orangeMedium, "sunrise", "#FEB674", "#FFCE85"];
        }
        return [colors.white, "sunrise", "#FEB674", "#d5d5d5"];
    }, [progress, isActive, hasReachedStopOvernight]);

    return useMemo(() => {
        return (
            <StickyGroupHeader
                iconName={iconName}
                bgColor={bgColor}
                color={color}
                iconBorderColor={iconBorderColor}
                iconColor={iconColor}
                topOffset={topOffset}
                setIsOpenItinerarySwitcher={setIsOpenItinerarySwitcher}
                showItinerarySwitcher={showItinerarySwitcher}
                currentPlaceName={props.currentPlaceName}
                inLauncherModal={inLauncherModal}
                withSticky={withSticky}
                isStickyOverride={isStickyOverride}
            >
                <strong>{`${translate("Day")} ${dayNumberFixed}`}</strong>
                {showDistance && (
                    <i className="dot" style={{ color: iconBorderColor }}>
                        {" • "}
                    </i>
                )}
                {dayDistance}
            </StickyGroupHeader>
        );
    }, [
        iconBorderColor,
        iconColor,
        color,
        iconName,
        translate,
        bgColor,
        topOffset,
        dayDistance,
        props.currentPlaceName,
        showDistance,
        setIsOpenItinerarySwitcher,
        showItinerarySwitcher,
        inLauncherModal,
        withSticky,
        isStickyOverride,
        dayNumberFixed,
    ]);
}

ItineraryDay.defaultProps = {
    withSticky: true,
    isStickyOverride: false,
};

const mapStateToProps = ({ progressByDay, currentPlaceName }) => ({
    progressByDay,
    currentPlaceName,
});

export default connect(mapStateToProps)(ItineraryDay);
